import { render, staticRenderFns } from "./LimitsReserch3View.vue?vue&type=template&id=f433c3e2&scoped=true"
import script from "./LimitsReserch3View.vue?vue&type=script&lang=js"
export * from "./LimitsReserch3View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f433c3e2",
  null
  
)

export default component.exports